(ns app.front.view.admin.migration.restrict-workspaces
  (:require [app.admin.migration.task :as-alias migration-task]
            [app.front.ui :as ui]
            [app.front.ui.section :as section]
            [app.front.ui.select :as ui-select]
            [app.front.view.admin.migration.template :as admin-migration-template]
            [app.front.view.group.admin.common :as acommon]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::fetch-candidates
  (fn [_ _]
    {:comm/command {:command    :admin/get-workspaces-exposed-to-siblings
                    :method     :get
                    :on-success [::fetch-candidates.success]}}))

(rf/reg-event-db ::fetch-candidates.success
  (fn [db [_ status {:keys [candidates help-text]}]]
    (if (= 200 status)
      (-> db
          (assoc ::candidates candidates)
          (assoc ::help-text help-text))
      db)))

(rf/reg-sub ::candidates :-> ::candidates)
(rf/reg-sub ::help-text :-> ::help-text)

(rf/reg-event-db ::set-selected
  (fn [db [_ selected]]
    (assoc db ::selected selected)))

(rf/reg-sub ::selected :-> ::selected)

(defn view [match]
  (let [tr                                                                                       (<sub [:tr])
        {:keys [total-count owner-group-id sibling-group-id owner-group-name sibling-group-name]
         :as   selected}                                                                         (<sub [::selected])]
    [acommon/admin-page (util/mmap {:title "Restrict workspaces for sibling groups"} match)
     [acommon/section {}
      [ui/help (<sub [::help-text])]
      [ui-select/select
       (util/mmap {:id         "select-group-pair"
                   :values     (<sub [::candidates])
                   :value      selected
                   :required   true
                   :val->str   (fn [{:keys [owner-group-name sibling-group-name]}]
                                 (str owner-group-name " -> " sibling-group-name))
                   :label-text "Select group to restrict"
                   :on-change  (fn [selected]
                                 (>evt [::set-selected selected]))}
                  tr)]
      (when selected
        [:div.my-4
         [section/subsection {:title "Selected groups"}
          [:div "Group that owns the workspaces: " [:span.bold owner-group-name] " (ID: " owner-group-id ")"]
          [:div "Group that will be restricted: " [:span.bold sibling-group-name] " (ID: " sibling-group-id ")"]
          [:div "Total workspaces to restrict: " total-count]]])
      [ui/modal-confirmation-button
       (util/mmap {:on-yes-click        (fn [_]
                                          (>evt [::admin-migration-template/create-migration-task
                                                 ::migration-task/restrict-workspaces-for-siblings
                                                 (select-keys selected [:owner-group-id
                                                                        :sibling-group-id
                                                                        :total-count])]))
                   :trigger-button-opts {:size :field}
                   :trigger-button-text "Start task"
                   :disabled?           (nil? selected)}
                  tr)
       [:p "Confirm that you want to restrict the visibility of " total-count
        "workspaces of " owner-group-id " for " sibling-group-id " members."]]]
     [admin-migration-template/previous-runs (util/mmap {:task-id ::migration-task/restrict-workspaces-for-siblings}
                                                        tr)]]))

(def route
  {:name        :view/admin.migration.restrict-workspaces-for-sibling-groups
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::fetch-candidates])
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  ::migration-task/restrict-workspaces-for-siblings]))}]})
